import React from 'react';

import CatalogoTiposSeguimiento from './CatalogoTiposSeguimiento';
import { getTipoSeguimientoSin, tablaTipoSeguimientoSin } from '../../../querys/TiposSeguimiento';
import { addTipoSeguimientoSin, updateTipoSeguimientoSin, deleteTipoSeguimientoSin } from '../../../mutations/TiposSeguimiento';

function TiposSeguimientoSiniestros() {
    return <CatalogoTiposSeguimiento
        titulo="Tipos de Seguimiento Siniestros"
        asyncGet={getTipoSeguimientoSin}
        asyncTabla={tablaTipoSeguimientoSin}
        asyncAdd={addTipoSeguimientoSin}
        asyncUpdate={updateTipoSeguimientoSin}
        asyncDelete={deleteTipoSeguimientoSin}
    />;
}

export default TiposSeguimientoSiniestros;
